import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=e22a223a&scoped=true&"
import script from "./UserDropdown.vue?vue&type=script&lang=js&"
export * from "./UserDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UserDropdown.vue?vue&type=style&index=0&id=e22a223a&scoped=true&lang=scss&"
import style1 from "./UserDropdown.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22a223a",
  null
  
)

export default component.exports